// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vpXv","col":"styles_col__CaOq0"};